import { useState } from 'react';
import PropTypes from 'prop-types';
import Search from '../../Search';
import styles from './AppTableSearch.module.scss';
import { PrimaryButton } from 'uiKit/atoms/Button/components/PrimaryButton';

const AppTableSearch = ({ handleSearch, title, placeholder }) => {
  const [inputValue, setInputValue] = useState('');

  const inputSubmitHandler = () => {
    handleSearch(inputValue.toLowerCase());
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          <h1>{title}</h1>
        </div>
        <div className={styles.search}>
          <Search
            value={inputValue}
            setValue={setInputValue}
            onSubmit={inputSubmitHandler}
            maxLength={50}
            placeholder={placeholder || ''}
          />
        </div>
        <div className={styles.button}>
          <PrimaryButton data-testid="button" onClick={inputSubmitHandler}>
            Search
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

AppTableSearch.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default AppTableSearch;
